module.exports = __webpack_public_path__ + "img/qianjiangjidi3.8d7f4605.png";